import Vue from 'vue'
import Router from 'vue-router'
const sparkInternal     =()=> import ('@/components/sparkInternal');
const sparkIndividual   =()=> import ('@/components/sparkIndividual');
const NotFoundComponent =()=> ('@/components/NotFoundComponent');
const sparkAdmin        =()=> import ('@/components/sparkAdmin');
const sparkLogin        =()=> import ('@/components/sparkLogin');
Vue.use(Router)

export default new Router({
  mode: 'history',

  routes: [
    {
      path: '/login',
      name: 'sparkLogin',
      component: sparkLogin
    },
    {
      path: '/',
      name: 'sparkInternal',
      component: sparkInternal
    },
    {
      path: '/id/:id',
      name: 'sparkIndividual',
      component: sparkIndividual
    },
    {
      path: '/admin/',
      name: 'sparkAdmin',
      component: sparkAdmin
    },
    {path: '*', 
    component: NotFoundComponent}
  ], 
})




// WEBPACK FOOTER //
// ./src/router/index.js